import API from '../utils/api';

export const getUsers = () => {
    // pageNumber
    return API.get(`/admin/users/get`);
};

export const getUserDetailsById = async (id) => {
    return API.get(`/admin/users/get/${id}/userDetails`)
        .then((response) => response)
        .catch((error) => error);
}

export const getUserOrdersById = async (userId, queryParams = "?recordsPerPage=100&pageNo=1") => {
    return API.get(`/admin/get/${userId}/user-orders${queryParams}`)
        .then((response) => response)
        .catch((error) => error);
}

export const getUserById = (id) => {
    return API.get(`/order/services/get/orders/${id}/order/history`);
};

;

export const deleteuser = (userId, cbFn) => {

    return API.get(`/admin/users/delete/${userId}`).then((response) => {
        console.log("response delete", response);
        if (response.data && response.data.status && response.data.status === 200) {
            cbFn(response.data.ResponseText);
        } else if (response.data && response.data.status !== 200) {
            cbFn(response.data.ResponseText, true);
        }
    }).catch((error) => {
        // console.log("delete user error:", error);
        cbFn('Unexpected Error', true);
    });
};